export default __webpack_public_path__ + "static/media/skyPondSlide2.7c714cc9.jpg";